export const SET_UPLOAD_TRACK_MODAL = "SET_UPLOAD_TRACK_MODAL";
export const SET_UPDATE_TRACK_MODAL = "SET_UPDATE_TRACK_MODAL";
export const SET_DELETE_TRACK_MODAL = "SET_DELETE_TRACK_MODAL";
export const SET_MY_PLAYLIST_MODAL = "SET_MY_PLAYLIST_MODAL";
export const SET_INFORMATION_MODAL = "SET_INFORMATION_MODAL";
export const SET_SHARE_MODAL = "SET_SHARE_MODAL";
